import { Link } from 'react-router-dom';
import { Routes } from '@/routes';
import { Credit } from '..';
import { IoWalletOutline } from 'react-icons/io5';

export function CreditButton() {
  return (
    <Link
      to={Routes.UserWallet}
      className="flex justify-center items-center no-underline ms-auto pe-1 text-[#0b5e62]"
    >
      <IoWalletOutline className="px-1 text-3xl" />
      <Credit inline numColor="#0b5e62" postfixColor="#0b5e62" />
    </Link>
  );
}

export default CreditButton;
